import { Anchor, Box, Button, CheckBox, FormField, Heading, Image, Text, TextInput } from "grommet";
import * as React from "react";
import { Attendee, AttendeeMetadata, CreateAttendee, GetAttendeeMetadata, UpdateMetadata, UpdateProfile, useUser } from "../utils/AccountStore";
import LinkButton from "../components/LinkButton";
import { set } from "lodash";
import { useNavigate } from "react-router-dom";

const Profile = () => {
    const { user } = useUser();

    const [metadata, setMetadata] = React.useState({} as AttendeeMetadata);

    const [firstName, setFirstName] = React.useState(user.firstName || "");
    const [lastName, setLastName] = React.useState(user.lastName || "");
    const [email, setEmail] = React.useState(user.email || "");
    const [mobileNumber, setMobileNumber] = React.useState(user.mobileNumber || "");
    const [school, setSchool] = React.useState(user.school || "");

    const [terms, setTerms] = React.useState(metadata?.terms || false);
    const [privacy, setPrivacy] = React.useState(metadata?.privacy || false);
    const [marketing, setMarketing] = React.useState(metadata?.marketing || false);

    React.useEffect(() => {
        let metadata = GetAttendeeMetadata(user);
        setFirstName(user.firstName || "");
        setLastName(user.lastName || "");
        setEmail(user.email || "");
        setMobileNumber(user.mobileNumber || "");
        setSchool(user.school || "");
        setTerms(metadata?.terms || false);
        setPrivacy(metadata?.privacy || false);
        setMarketing(metadata?.marketing || false);
    }, [user]);

    const navigate = useNavigate();

    const complete = () => {
        UpdateProfile({
            id: user.id,
            firstName: firstName,
            lastName: lastName,
            email: email,
            mobileNumber: mobileNumber,
            school: school,
            hasSeenWelcomePage: true,
            favorites: user.favorites,
            visited: user.visited,
            mySchedule: user.mySchedule,
        } as Attendee).then((res) => {
            UpdateMetadata(user, {
                terms: terms,
                privacy: privacy,
                marketing: marketing,
            }).then(() => {
                navigate("/home");
            });
        });
    };

    return (
        <Box align="center" background={{ image: "url('/images/background.png')" }} justify="center" height={"var(--vh)"} width={"100vw"}>
            <Box align="center" background={"background-front"} pad={"medium"} round="10px" width={"90vw"}>
                {/* <Image margin="small" alignSelf="left" fit="contain" src="/images/logo.png" width={logoMaxSize} /> */}
                <Text size="large">Register</Text>
                {user.id && (
                    <Box fill>
                        <FormField label="First Name">
                            <TextInput placeholder="First Name" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                        </FormField>
                        <FormField label="Last Name">
                            <TextInput placeholder="Last Name" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                        </FormField>
                        <FormField label="Email">
                            <TextInput placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                        </FormField>
                        <FormField label="Mobile Number">
                            <TextInput placeholder="Mobile Number" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} />
                        </FormField>
                        <FormField label="Company">
                            <TextInput placeholder="Company" value={school} onChange={(e) => setSchool(e.target.value)} />
                        </FormField>
                        <Box direction="row" gap="small" margin={{ vertical: "medium" }}>
                            <CheckBox checked={terms} onChange={(e) => setTerms(e.target.checked)} />
                            <Text>Accept Terms and Conditions</Text>
                        </Box>
                        <Box direction="row" gap="small" margin={{ vertical: "medium" }}>
                            <CheckBox checked={privacy} onChange={(e) => setPrivacy(e.target.checked)} />
                            <Text>Accept Privacy Policy</Text>
                        </Box>
                        <Box direction="row" gap="small" margin={{ vertical: "medium" }}>
                            <CheckBox checked={marketing} onChange={(e) => setMarketing(e.target.checked)} />
                            <Text size="small">I consent to receive updates about events, special offers, and news from Lenovo via email and SMS.</Text>
                        </Box>

                        <Button label="Continue" primary disabled={!terms} onClick={complete}></Button>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default Profile;
